import * as types from 'actions/toast/types';

const initialState = {};
export default (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW:
      const { options } = action.payload;
      return { ...state, show: true, options };
    case types.HIDE:
      return { ...initialState.toast, show: false };
    default:
      return state;
  }
};
